import '@ausbom/button/lib/scss/module.scss';
import { default as HeaderBase, HeaderTitle } from '@ausbom/header';
import '@ausbom/header/lib/scss/module.scss';
import { Link } from '@tanstack/react-router';
import { Route as landingRoute } from '../../routes/index';
import './AppHeader.scss';

export default function AppHeader() {
  return (
    <header className="wmw-header">
      <HeaderBase
        renderTitle={() => (
          <Link to={landingRoute.to}>
            <HeaderTitle
              linkAs="div"
              long="The Bureau of Meteorology - Water markets data"
              short="The Bureau of Meteorology - Water markets data"
            />
          </Link>
        )}
      />
    </header>
  );
}
